// biome-ignore lint/complexity/noStaticOnlyClass: <explanation>
export default class DataLayerEnum {
    static CARD = '.iris-card'
    static CARD_TITLE = '.iris-card__content__title'
}
